import React, { useEffect, useState } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faPlay,
  faPause,
  faBackwardStep,
  faForwardStep,
  faVolumeHigh,
  faVolumeMute,
} from "@fortawesome/free-solid-svg-icons";
import getSong from "../api/getSong";

export default function Player({
  setIsPlaying,
  isPlaying,
  currentSong,
  setCurrentSong,
  songs,
  setSongs,
  songInfo,
  setSongInfo,
  timeUpdateHandler,
  audioRef,
  nextSongHandler,
  setIsLoading
}) {
  const [volume, setVolume] = useState(1);
  const [muted, setMuted] = useState(false);

  //EFFECT
  useEffect(() => {
    const newSongs = songs.map((song) => {
      if (song.id === currentSong.id) {
        return { ...song, active: true };
      } else {
        return { ...song, active: false };
      }
    });
    setSongs(newSongs);
  }, [currentSong]);

  // HANDLERS

  const previousSongHandler = async () => {
    const currentIndex = songs.findIndex((song) => {
      return currentSong.id === song.id;
    });
    const previousSongIndex = currentIndex - 1;
    if (previousSongIndex >= 0) {
      const previousSong = await getSong(songs[previousSongIndex].id);
      setCurrentSong(previousSong);
      setIsLoading(false);
    } else {
      setCurrentSong(currentSong);
    }
    if (isPlaying) {
      audioRef.current.play();
    }
  };

  const playHandler = () => {
    if (isPlaying) {
      audioRef.current.pause();
      setIsPlaying(!isPlaying);
    } else {
      audioRef.current.play();
      setIsPlaying(!isPlaying);
    }
  };

  const getTime = (time) => {
    return (
      Math.floor(time / 60) + ":" + ("0" + Math.floor(time % 60)).slice(-2)
    );
  };
  const dragHandler = (e) => {
    audioRef.current.currentTime = e.target.value;
    setSongInfo({ ...songInfo, currentTime: e.target.value });
  };

  return (
    <div className="BottomBar flex flex-col items-center justify-center h-24 w-[98%] sm:w-[90%] md:w-[75%] fixed bottom-1 md:left-[12%] sm:left-[5%] left-[1%] overflow-hidden ">
      <div className="time-contol relative w-full top-3 z-10">
        <input
          min={0}
          max={songInfo.duration || 0}
          value={songInfo.currentTime}
          onChange={dragHandler}
          type="range"
          className="w-full accent-[#FF8427] outline-none"
        />
      </div>
      <div className="Player font-varela dark:bg-[#0d0f17] bg-[#fce168] flex flex-row space-x-8 sm:space-x-2 rounded-lg relative h-24 w-full max-w-full dark:text-[#FFFFFF] text-[#0d0f17]">
        <div className="Songinfo flex flex-row items-center sm:gap-x-2 sm:w-[40%] w-[70%]  text-sm pl-5">
          <span className="cover truncate w-16 sm:w-11">
            <img
              src={currentSong.imageUrl}
              alt="song-cover"
              className="h-10 w-10 rounded-sm object-cover"
            />
          </span>
          <span className="truncate w-40 sm:w-[80%]">
            <p>{currentSong.title}</p>
            {/* <p className="text-slate-700 text-xs truncate">
              {currentSong.artist}
            </p> */}
          </span>
        </div>

        <div className="play-control flex items-center justify-center gap-x-3 sm:gap-x-10 text-xl sm:text-2xl sm:w-[20%]">
          <button
            className=" previousBtn cursor-pointer "
            onClick={() => previousSongHandler()}
          >
            <FontAwesomeIcon icon={faBackwardStep} />
          </button>
          <button
            className="playBtn cursor-pointer "
            onClick={() => playHandler()}
          >
            {isPlaying ? (
              <FontAwesomeIcon icon={faPause} />
            ) : (
              <FontAwesomeIcon icon={faPlay} />
            )}
          </button>
          <button
            className="nextBtn cursor-pointer "
            onClick={() => nextSongHandler()}
          >
            <FontAwesomeIcon icon={faForwardStep} />
          </button>
        </div>
        <div className="flex justify-center items-center w-[30%] absolute right-1 top-5 gap-x-8 md:gap-x-4 sm:gap-x-3 text-slate-600 invisible sm:visible">
          <span>
            {getTime(songInfo.currentTime)}/
            {songInfo.duration ? getTime(songInfo.duration) : "0:00"}
          </span>
          <span className="flex md:gap-x-2 sm:gap-x-1 justify-center items-center ">
            {muted ? (
              <FontAwesomeIcon
                icon={faVolumeMute}
                className="text-[#FF8427] cursor-pointer"
                onClick={() => {
                  setMuted(!muted);
                  setVolume(1);
                  audioRef.current.volume = 1;
                }}
              />
            ) : (
              <FontAwesomeIcon
                icon={faVolumeHigh}
                className="text-[#FF8427] cursor-pointer"
                onClick={() => {
                  setMuted(!muted);
                  setVolume(0);
                  audioRef.current.volume = 0;
                }}
              />
            )}
            <input
              type="range"
              min={0}
              max={1}
              step={0.02}
              value={volume}
              onChange={(event) => {
                audioRef.current.volume = event.target.valueAsNumber;
                setVolume(event.target.valueAsNumber);
              }}
              className="rounded-xl w-16 accent-[#FF8427] "
            />
          </span>
        </div>
      </div>

      {/* space */}
    </div>
  );
}
